import { formatDate, getTime } from '@/helpers/format-date';
import i18n from '@/api/i18n/i18n';

import { groupFieldMap } from '@/views/notifications/const/const';

const isObjectData = (value) => value && typeof value === 'object' && !Array.isArray(value);

const getLocalValue = (field, el) => i18n.t(`db.${field}.${el}`);
const getFormatDate = (value) => `${formatDate(value)} ${getTime(value)}`;

export const getDataField = (item, field) => {
  const isObject = isObjectData(item);
  const validField = groupFieldMap[field] ?? field;
  const value = isObject ? item[validField] : item;

  if (!value || value === 'null') return '';

  const mappings = {
    eventTypeName: () => getLocalValue(field, value),
    reasonString: () => getLocalValue(field, value),
    categoryName: () => getLocalValue(field, value),
    eventTime: () => getFormatDate(value),
    date: () => getFormatDate(value),
    checkTime: () => {
      const date = new Date(value);
      return date.getTime() === 0 ? '' : value;
    },
    descriptionOutput: () => value.slice(0, 134),
  };
  return mappings[field] ? mappings[field]() : value;
};

export const getLabel = (label) => {
  const isDbString = typeof label === 'string' && label.startsWith('$');
  return isDbString ? i18n.t(`db.${label}`) : label;
};
